module.exports = __webpack_public_path__ + "img/attendance_record-blue.f18362a9.svg";